"use client";
import React, { useState } from "react";


export type accordion_type = {
  id: number,
  tab_id: string,
  question: string,
  answer_text?: (string)[] 
  answer_nodes?: React.ReactNode
}

type Props = {
  id: string
    content: accordion_type[]
    className?: string
}


const AccordionBlock: React.FC<Props> = ({id,content, className}) => {
  const [active, setActive] = useState(-1);

  const handleItemClick = (index: number) => {
    console.log('Active: ', index)
    setActive(index);
  };

  return (
    <div id={`accordion-${id}`} className={`container ${className}`}>
      <div className="p-relative z-index-1">
        <div className="gx-0">
            <div
              className="tp-accordion p-relative mt-40">
              <span className="tp-accordion-border"></span>
              <div className="accordion">
                {content.map((item, i) => (
                  <div
                    key={i}
                    onClick={() => handleItemClick(i)}
                    className={`accordion-item tp-services-accordion-item ${
                      active === i ? "active" : ""
                    }`}
                  >
                    <h2
                      className="accordion-header"
                      id={`heading${item.tab_id}`}
                    >
                      <button
                        className={`accordion-button collapsed`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${item.tab_id}`}
                        aria-expanded={`false`}
                        aria-controls={`collapse${item.tab_id}`}
                        tabIndex={0}
                      >
                        <span>0{item.id}</span>
                        {item.question}
                        <span className="accordion-btn-wrap">
                          <span className="accordion-btn"></span>
                        </span>
                      </button>
                    </h2>
                    <div
                      id={`collapse${item.tab_id}`}
                      className={`accordion-collapse collapse`}
                      aria-labelledby={`heading${item.tab_id}`}
                      data-bs-parent={`#accordion-${id}`}
                    >
                      <div className="accordion-body">
                        {item.answer_text?.map((text, index) => (<p key={index}>{text}</p>))}
                        {item.answer_nodes}
                      </div>
                    </div>
                    <span className="accordion-item-border"></span>
                  </div>
                ))}
              </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionBlock;
